export default "__VITE_ASSET__7b29962f__"